import { SEO } from "@/lib/seo";
import { PageHero } from "@/components/common/PageHero";

export default function PrivacyPolicy() {
  return (
    <div data-testid="privacy-policy-page">
      <SEO title="Privacy Policy" description="Privacy Policy for WomensMatchDayLive." path="/privacy-policy" />
      <PageHero eyebrow="Legal" title="Privacy Policy" crumbLabel="Privacy Policy" />
      <section className="bg-white py-16">
        <div className="mx-auto max-w-3xl space-y-8 px-6 lg:px-12">
          {["Introduction", "Data We Collect", "How We Use Your Data", "Cookies", "Your Rights", "Contact Us"].map((heading) => (
            <div key={heading}>
              <h2 className="font-heading text-2xl uppercase text-brand-black">{heading}</h2>
              <p className="mt-2 text-black/60">Text goes here</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
